import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule, HttpParams } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { SERVER_API_URL } from '../../../app.constants';
import { filter } from 'rxjs';
@Component({
  selector: 'app-stripe-redirect',
  standalone: true,
  templateUrl: './stripe-redirect.component.html',
  styleUrl: './stripe-redirect.component.scss',
  imports: [CommonModule, HttpClientModule, RouterModule]
})
export class StripeRedirectComponent implements OnInit {

  status: 'pending' | 'success' | 'error' = 'pending';

  constructor(private route: ActivatedRoute, private http: HttpClient,private router: Router) { }

 ngOnInit(): void {
      
  const sessionId = this.route.snapshot.queryParamMap.get('session_id');
  const statusPaketa = this.route.snapshot.queryParamMap.get('status');

  if (sessionId) {
    const params = new HttpParams().set('session_id', sessionId);

    this.http
    .get<boolean>(`${SERVER_API_URL}api/invoices/stripeSuccess`, {
      params
    }).subscribe({
      next: (result: boolean) => {
        if (result) {
          this.status = 'success';
          setTimeout(() => {
             const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('session_id');
            currentUrl.searchParams.set('status', 'uspesnoPlacenPaket');
            window.location.href = currentUrl.toString();
          }, 2500);
          
        } else {
          this.status = 'error';
          setTimeout(() => {
             const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('session_id');
            currentUrl.searchParams.set('status', 'neUspesnoPlacenPaket');
            window.location.href = currentUrl.toString();
          }, 2500);
        }
      },
      error: () => {
        this.status = 'error';
        window.location.href = 'myapp://payment-error';
      }
    });
  } else if (statusPaketa === 'uspesnoPlacenPaket'){
    this.status = 'success';
  } else if (statusPaketa === 'neUspesnoPlacenPaket'){
    this.status = 'error';
  } else {
    this.status = 'error';
  }
}

  goToDashboard() {
    window.location.href = '/dashboard';
  } 

  retry() {
    window.location.reload();
  }

   
}
